export type ImageMimeType = 'image/jpeg' | 'image/png' | 'image/webp';

export interface PresignRequestForm {
  loan_application_id?: number;
  field_visit_location_id?: number; // not required for presign (sent at finalize)
  filename: string;
  content_type: ImageMimeType;
  visit_type?: string; // UI label, e.g. "Customer Visit - House"
  doc_category_id?: number;
}

export interface PresignResponse {
  upload_url: string;
  s3_key: string;
  method?: 'POST' | 'PUT';
  fields?: Record<string, string>;
}

export interface FinalizeDocumentRequest {
  applicant_id: string;
  loan_application_id: number;
  field_visit_location_id?: number;
  doc_category_id: number;
  file_name: string;
  s3_key: string;
  repayment_id?: number;
  activity_log_id?: number;
  /** Preferred link for collection receipts */
  collection_transaction_id?: number;
  mime_type?: ImageMimeType;
  size_bytes?: number;
  notes?: string;
}

export interface DocumentItem {
  id: number;
  applicant_id: string;
  loan_application_id: number;
  field_visit_location_id?: number;
  activity_log_id?: number;
  collection_transaction_id?: number;
  doc_category_id: number;
  file_name: string;
  url: string;
  s3_key?: string;
  mime_type?: string;
  size_bytes?: number;
  created_at?: string;
  updated_at?: string;
}

export interface DocumentsByVisitResponse {
  items: DocumentItem[];
}

export interface DocumentsByLoanResponse {
  items: DocumentItem[];
}

/** GET /documents/depositable — cash_in_hand txns eligible for multi deposit slip */
export interface DepositableTransaction {
  transaction_id: number;
  loan_id: number;
  applicant_id: string;
  applicant_name: string;
  amount: number;
  paid_at?: string | null;
  payment_mode?: string | null;
  cash_in_hand?: number;
}

export interface DepositableTransactionsResponse {
  total: number;
  transactions: DepositableTransaction[];
}

/** POST /documents/deposit-batch — one slip → many collection txns */
export interface DepositBatchRequest {
  transaction_ids: number[];
  s3_key: string;
  file_name: string;
  doc_category_id?: number;
  notes?: string | null;
}

export interface DepositBatchResponse {
  deposit_batch_id: string;
  transaction_ids: number[];
  total_amount: number;
  document_ids: number[];
  receipt_url?: string;
  message?: string;
}

/** RECEIPT category for Multiple Cash Deposit (deposit-batch default) */
export const DOC_CATEGORY_DEPOSIT_BATCH = 4;

